/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

const styles = {
};

export = styles;

loadStyles([{"rawString":".ms-JobIconExample{margin-right:5px}"}]);
/* tslint:enable */